import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0e4dee95&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e4dee95')) {
      api.createRecord('0e4dee95', component.options)
    } else {
      api.reload('0e4dee95', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=0e4dee95&", function () {
      api.rerender('0e4dee95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/Index.vue"
export default component.exports